import { render, staticRenderFns } from "./MailChangeAuthorization.vue?vue&type=template&id=44e346b8&scoped=true&"
import script from "./MailChangeAuthorization.vue?vue&type=script&lang=js&"
export * from "./MailChangeAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./MailChangeAuthorization.vue?vue&type=style&index=0&id=44e346b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e346b8",
  null
  
)

export default component.exports